import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import API_URL from "../config";

// Se activa solo si REACT_APP_GA_MEASUREMENT_ID está configurado (Render → env vars).
// Sin esa variable, este componente no hace nada — no carga ningún script de terceros.
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

// Tracking propio (independiente de GA) para que el panel de staff de Procu
// pueda mostrar tráfico sin depender de un dashboard externo.
const VISITOR_ID_KEY = "procu_visitor_id";

const getVisitorId = () => {
  let visitorId = localStorage.getItem(VISITOR_ID_KEY);
  if (!visitorId) {
    visitorId = crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(VISITOR_ID_KEY, visitorId);
  }
  return visitorId;
};

const trackPageView = (path) => {
  const currentUserId = localStorage.getItem("current_user_id");
  const token = currentUserId
    ? localStorage.getItem(`access_token_${currentUserId}`)
    : null;

  fetch(`${API_URL}/analytics/pageview`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({
      path,
      visitor_id: getVisitorId(),
      referrer: document.referrer || null,
    }),
  }).catch(() => {
    // Best-effort: si falla, no interrumpe la navegación del usuario.
  });
};

let initialized = false;

const initGoogleAnalytics = () => {
  if (initialized || !GA_MEASUREMENT_ID) return;
  initialized = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  // send_page_view en false porque en una SPA disparamos el page_view nosotros
  // en cada cambio de ruta (ver useEffect de abajo), no solo en la carga inicial.
  window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });
};

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    initGoogleAnalytics();
  }, []);

  useEffect(() => {
    if (!GA_MEASUREMENT_ID || !window.gtag) return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
    });
  }, [location]);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

export default Analytics;
